import React, { useState, useEffect, useRef, useContext } from "react";
import Lottie from "lottie-web";
import MyContext from "../../context/MyContext";
import TickerContext from "../../context/ticker";
import AuthContext from "../../context/userAuth.context";

const PandS_loader = ({ value }) => {
  const AnimationRef = useRef(null);

  const { CanvasDisplay, onePxEquivalent } = useContext(MyContext);

  const { TickerPosition, TickerStart } = useContext(TickerContext);

  const [AnimationData, setAnimationData] = useState(null);

  const [played, setplayed] = useState(false);

  const [state, setstate] = useState(true);
  const { authenticationData } = useContext(AuthContext);

  // useEffect(() => {
  //   if (!played) {
  //     if (value.Added) {
  //       // const ctx = AnimationRef.current.getContext('2d');
  //       const getter = Lottie.loadAnimation({
  //         container: AnimationRef.current,
  //         name: value.AnimationId,
  //         renderer: "svg",
  //         loop: true,
  //         autoplay: true,
  //         // path: authenticationData.ApiBaseURL+"/"+value.AnimationPath,
  //         animationData: value.JSONValue,
  //         rendererSettings: {
  //           preserveAspectRatio: "xMidYMin slice",
  //           viewBoxOnly: true,
  //           progressiveLoad: true,
  //         },
  //       });
  //       setAnimationData(getter);
  //       setplayed(true);
  //       getter.addEventListener("loopComplete", function () {
  //         setstate(false);
  //         getter.stop(value.AnimationId);
  //         getter.removeEventListener("loopComplete");
  //       });
  //       value.Added = false;
  //     }
  //   }
  // }, [value.AnimationPath]);

  // useEffect(() => {
  //     if (played == true) {
  //         if (TickerStart == true) {
  //             setstate(true)
  //         } else if (TickerStart == false) {
  //             setstate(false)
  //         }
  //     }
  // }, [TickerStart]);

  // useEffect(() => {
  //     if (AnimationData != null) {
  //         if (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) {

  //             let playedtime = TickerPosition - value.startPositionOnTimeline//in px
  //             let jsonTotaltime = AnimationData.totalFrames
  //             let fm = AnimationData.frameRate
  //             let ms = (playedtime * onePxEquivalent) / 1000
  //             let playedFrame = ms * fm
  //             let Playon = null;

  //             if (playedFrame > jsonTotaltime) {
  //                 while (true) {
  //                     let start = playedFrame - jsonTotaltime
  //                     if (start < jsonTotaltime) {
  //                         Playon = start
  //                         break
  //                     } else {
  //                         playedFrame = start
  //                     }
  //                 }
  //             } else {
  //                 Playon = playedFrame
  //             }
  //             AnimationData.goToAndStop(Playon, true, value.AnimationId)
  //         }
  //     }
  // }, [TickerPosition]);

  // useEffect(() => {
  //     if (!CanvasDisplay) {
  //         if (played) {
  //             setstate(true)
  //         }
  //     } else {
  //         if (played) {
  //             setstate(false)
  //             AnimationData.stop(value.AnimationId)
  //         }
  //     }
  // }, [CanvasDisplay]);

  // useEffect(() => {
  //     if (AnimationData != null) {
  //         loadAgain()
  //     }
  // }, [value.width]);

  // useEffect(() => {
  //     if (value.player) {
  //         if (played) {
  //             setstate(true)
  //             let playedtime = TickerPosition - value.startPositionOnTimeline//in px
  //             let jsonTotaltime = AnimationData.totalFrames
  //             let fm = AnimationData.frameRate
  //             let ms = (playedtime * onePxEquivalent) / 1000
  //             let playedFrame = ms * fm
  //             let Playon = null;

  //             if (playedFrame > jsonTotaltime) {
  //                 while (true) {
  //                     let start = playedFrame - jsonTotaltime
  //                     if (start < jsonTotaltime) {
  //                         Playon = start
  //                         break
  //                     } else {
  //                         playedFrame = start
  //                     }
  //                 }
  //             } else {
  //                 Playon = playedFrame
  //             }
  //             if (Playon <= 0) {
  //                 Playon = 0
  //             }
  //             AnimationData.goToAndPlay(Playon, true, value.AnimationId)
  //             AnimationData.loop = true
  //         }
  //     } else if (!value.player) {
  //         if (played) {
  //             setstate(false)
  //             AnimationData.stop(value.AnimationId)
  //         }
  //     }
  // }, [value.player]);

  // const loadAgain = () => {
  //     setstate(false)
  //     const ctx = AnimationRef.current.getContext('2d');
  //     Lottie.destroy(value.AnimationId)
  //     setAnimationData(null)
  //     const getter = Lottie.loadAnimation({
  //         name: value.AnimationId,
  //         renderer: 'canvas',
  //         loop: false,
  //         autoplay: false,
  //         path: authenticationData.ApiBaseURL+"/"+value.AnimationPath,
  //         rendererSettings: {
  //             context: ctx,
  //             clearCanvas: true,
  //             preserveAspectRatio: 'xMidYMid meet'
  //         }
  //     })

  //     setAnimationData(getter)
  //     // getter.goToAndPlay(Cf, true)
  //     // getter.addEventListener('enterFrame', function () {
  //     //     setAnimationData(getter)
  //     //     getter.removeEventListener('enterFrame')
  //     // })
  //     //let count = 0
  //     // getter.addEventListener('loopComplete', function () {

  //     //     if (count === 2) {
  //     //         getter.stop(name)
  //     //         getter.removeEventListener('loopComplete')
  //     //     }
  //     //     count++
  //     // })
  // };

  return (
    <>
      <div
        draggable="false"
        id={"props-"+ value.AnimationId}
        style={{
          opacity: value.opacity,
          display: value.InMultiDrag ? "none" : "block",
          transform: (!CanvasDisplay ? ` rotate(${value.rotateAngle}deg) ` + value.flip : value.flip),
          width: "100%",
          height: "100%",
          position: "absolute",
          top: "0px",
          zIndex: -1,
        }}
      >
        {/* <img src={authenticationData.ApiBaseURL+"/"+ value.PropImage} draggable="false" style={{ display: state == false ? 'block' : 'none', width: '100%', height: '100%' }} /> */}
        {/* <canvas ref={AnimationRef} id={"Canvas-"+value.AnimationId} style={{ display: state == true ? 'block' : 'none' }} className={"propCan "} width={value.width} height={value.height} /> */}
        <div
          ref={AnimationRef}
          id={"Canvas-" + value.AnimationId}
          width={value.width}
          height={value.height}
        />
      </div>
    </>
  );
};
export default PandS_loader;
